var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMenuFineArtIcon = function SvgMenuFineArtIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "main-color-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 108767",
    d: "M21.748 16.027V3.02A3.021 3.021 0 0 0 18.728 0h-15.7a3.021 3.021 0 0 0-3.02 3.02v13.007a16.555 16.555 0 0 1 21.74 0ZM6.648 3.02a3.624 3.624 0 1 1-3.624 3.624A3.623 3.623 0 0 1 6.649 3.02Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 108768",
    d: "M9.065 6.644a2.416 2.416 0 1 1-2.416-2.416 2.416 2.416 0 0 1 2.416 2.416"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 108769",
    d: "M21.71 17.64a15.342 15.342 0 0 0-21.674 0c-.012.012-.024.018-.037.031v1.053a3.021 3.021 0 0 0 3.02 3.02h15.7a3.021 3.021 0 0 0 3.02-3.02V17.67a.426.426 0 0 1-.037-.031Z"
  })));
};
export default SvgMenuFineArtIcon;